import { useState, useMemo, useEffect, useRef } from "react";

import { ReactComponent as DeleteIcon } from "../../../assets/images/icon_svg/delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/icon_svg/edit.svg";
import Trash from "../../../assets/images/delete.svg";
import TableGrid from "../../../Components/common/TableGrid";
import { useSelector } from "react-redux";
import TableFilters from "../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../Components/common/TableGrid/TableTabs";

import { CallApi } from "../../../Components/common/CommonFunctions";
import { toast } from 'react-toastify';

import { useDispatch } from "react-redux";

import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../redux/features/table/tableSlice";

import { useGetTripsListQuery } from "../../../redux/services/Trucking";
import TripModal from "../../Handler/SlotPlanning/common/TripModal";
import TripEditModal from "./common/TripEditModal";
import ConfModal from "../../../Components/common/ConfModal";

const Trips = (gridRefetch) => {

  const isMounted = useRef(false);
  const [warehouse, setWarehouse] = useState([]);
  const [disLoading, setDisLoading] = useState(false);
  const [sendData, setSendData] = useState({});
  const [rowData, setrowData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showTripEditModal, setShowTripEditModal] = useState(false);
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

  const [modalConf, setModalConf] = useState(false)
  const [deleteId, setDeleteId] = useState()

  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};

    if (!entries.length) return params;

    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });

    params.filterscount = entries.length;

    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useGetTripsListQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const fetchWarehousOrgnaziation = async () => {
    CallApi({
      endPoint: `trip-management/slot-warehouse-organizations`,
      method: 'get',
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        setWarehouse(innerData?.warehouses);
      },
      onError: (msg) => toast.error(msg)
    });
  };


  useEffect(() => {
    if (isMounted.current) return;
    fetchWarehousOrgnaziation();
    dispatch(onTabChange({ key: 'tab', value: "0" }));
    isMounted.current = true;
  }, []);
  useEffect(() => {
    if (gridRefetch.gridRefetch == true) {
      refetch();
    }
  }, [gridRefetch]);

  const filtersConfig = [
    {
      type: "input",
      field: "trip_no",
      placeholder: "Search Trip No.",
    },
    {
      type: "input",
      field: "truck_nos",
      placeholder: "Search Truck No.",
    },
    {
      type: "multiselect",
      field: "warehouse_id",
      placeholder: "Warehouse",
      options: warehouse?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || [],
    },
  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: null },
    { label: "Open", value: "0", paramKey: "tab" },
    { label: "Completed", value: "1", paramKey: "tab" },
  ];

  const dispatch = useDispatch();


  // const [toggleSlotStatus, { isLoading: archiveLoading }] = useToggleSlotStatusMutation();

  // const handleArchive = async (rows) => {
  //   try {
  //     const ids = rows.map((r) => r.id);
  //     // await toggleSlotStatus({ ids: ids }).unwrap();
  //     toast.success("Status updated");
  //     refetch();
  //     dispatch(clearSelectedRowsData(true));
  //   } catch (err) {
  //     toast.error("Updation failed");
  //   }
  // };

  const loadDetails = (rowData, pos) => {
    setSendData({ id: rowData.id, ps: pos, trip_id: rowData.trip_id })
    setShowModal(true)
  };
  const loadEditDetails = (rowData, pos) => {
    setrowData(rowData)
    setShowTripEditModal(true)
    setShowModal(false);
  };

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'single_action',
      renderCell: (row) => (<div className="tb_grid_actions">
        <EditIcon className="icon_blue" style={{ cursor: "pointer", marginRight: "15px" }}
          onClick={(e) => {
            e.stopPropagation();
            loadEditDetails(row, "V");
          }}
        />
        <DeleteIcon className="icon_blue" style={{ cursor: "pointer", marginRight: "15px" }}
          onClick={(e) => {
            e.stopPropagation();
            setDeleteId(row.trip_id);
            setModalConf(true)
          }}
        />
      </div>),
    },
    {
      label: "Trip No", field: "trip_no", enableSearch: false, cls: 'tw-8',
      renderCell: (row) => (<span className="text_blue extra_height" onClick={(e) => { e.stopPropagation(); loadDetails(row, "V"); }}>{row?.trip?.trip_no}</span>),
    },
    { label: "Truck No", field: "truck_nos", enableSearch: false, cls: 'tw-10', },
    {
      label: "Operation", field: "shipping_type", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => {
        let shipping_type;
        if (row?.shipping_type == 'L') { shipping_type = "Loading" } else if (row?.shipping_type == 'U') { shipping_type = "Unloading" }
        return <span>{shipping_type}</span>;
      },
    },
    {
      label: "Vehicle No", field: "vehicle_no", enableSearch: false, cls: 'tw-7',
      renderCell: (row) => (<span>{row?.all_trips[0]?.vehicle_no}</span>),
    },
    { label: "Handler Name", field: "handler_name", enableSearch: false, cls: 'tw-7' },
    { label: "Station", field: "station", enableSearch: false, cls: 'tw-5' },
    {
      label: "Planned Time", field: "planned_time", enableSearch: false, cls: 'tw-9',
      renderCell: (row) => (<span> {row?.planned_date_time?.slice(0, 16)}</span>),
    },
    {
      label: "Timeslot", field: "timeslot", enableSearch: false, cls: 'tw-9',
      renderCell: (row) => {
        const start = row?.all_trips?.[0]?.slot_start_time?.slice(11, 16);
        const end = row?.all_trips?.[0]?.slot_end_time?.slice(11, 16);
        return <span>{start && end ? `${start} - ${end}` : ''}</span>;
      },
    },
    {
      label: "Arrival Window", field: "arrival_window", enableSearch: false, cls: 'tw-9',
      renderCell: (row) => (<span className="bold_text">{row?.all_trips[0]?.arrival_window}</span>),
    },
    {
      label: "Status", field: "status", enableSearch: false,
      renderCell: (row) => {
        let status
        const status_id = row?.all_trips?.[0]?.trip_status?.id;
        const status_name = row?.all_trips?.[0]?.trip_status?.name || "";
        if (status_id == 210 || status_id == 211) {
          let shippingType = "";
          if (row?.shipping_type === "L") {
            shippingType = "Loading ";
          } else if (row?.shipping_type === "U") {
            shippingType = "Unloading ";
          }
          status = shippingType + status_name;
        } else {
          status = status_name;
        }
        return <span>{status}</span>;
      },
    },
  ];

  // const bulkActions = tab?.value === "A"
  //   ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
  //   : tab?.value === "R"
  //     ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
  //     : [];

  const closeModal = () => {
    setShowTripEditModal(false);
    setrowData({});
    refetch();
  }
  const handleConfDelete = () => {
    CallApi({
      endPoint: 'trip-management/delete-trip',
      payload: { trip_id: deleteId },
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success('Trip Removed Successfully')
          refetch()
          setModalConf(false);
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }

  return (
    <>
      {modalConf &&
        <ConfModal
          header={`Delete Trip`}
          subHeader={`Are you sure you want to delete this Trip?`}
          modalConf={() => handleConfDelete()}
          closeModal={() => setModalConf(false)}
          primaryBtn='Delete'
          secondaryBtn='Cancel'
        />
      }
      {/* {console.log("formData", formData)} */}
      {disLoading ? <div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div> : ''}
      {showModal &&
        <TripModal propData={sendData} show={showModal} page="trips" onHide={() => setShowModal(false)} onEditTrip={(rowData) => { loadEditDetails(rowData, "V"); }} />
      }
      {showTripEditModal &&
        <TripEditModal
          rowData={rowData}
          // setRowData={setRowData}
          // onSuccess={refreshGrid}
          onClose={closeModal}
        // mode={mode}
        // setMode={setMode}
        />
      }
      <div className="main-content">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={myData?.Rows}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
            }}
            loading={isFetching}
            // bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
      </div>
    </>
  )
}

export default Trips